import { EServiceTypes } from '../../../../repositories/billing-tariffs/entities/Models/TariffIdentificator';
import { EServiceId } from '../../../../types/reducers/publishTerms';

export function mapServiceId(serviceType: EServiceTypes): EServiceId {
  switch (serviceType) {
    case EServiceTypes.DebitObject:
      return EServiceId.paid;
    case EServiceTypes.Top3:
      return EServiceId.top;
    case EServiceTypes.PremiumObject:
      return EServiceId.premium;
  }

  return EServiceId.free;
}
